// services/userService.ts
import axiosInstance from '../../services/http.api';
import { DEFAULT_ERROR_MSG } from '../../utils/constants';
import { dateConversion } from '../../utils/dateHandler';
import { getStatusLabel } from '../../utils/statusHandler';
import { LogoRequest } from './logoRequestList.types';

export const logoRequestListService = {

    /**
     * Fetch logo requests
     * @param certificateId 
     * @returns Logo request array list
     */
    fetchLogoRequests: async (certificateId: string): Promise<LogoRequest[]> => {
        try {
            const res = await axiosInstance.get<any>(`/v1/LOGORequest/certificate/${certificateId}`);

            if (!res.data.isSuccess) {
                // Throw an error with custom message from backend
                throw new Error(res.data.message || DEFAULT_ERROR_MSG);
            }

            const data = res.data.logoRequests || [];
            const logoRequests: LogoRequest[] = data.map((logoRequest: any) => ({
                requestId: logoRequest.id,
                requestName: logoRequest.name,
                requestType: logoRequest.requestType,
                submittedDate: logoRequest.submittedDate,
                status: logoRequest.status,
                jobName: logoRequest.jobName,
                jobId: logoRequest.jobNumber,
                siteName: logoRequest.siteId,
                convertedSubmittedDate: dateConversion(logoRequest.submittedDate, "MMMM d, yyyy"),
                displayStatus: getStatusLabel(logoRequest.status)
            }));

            return logoRequests;
        } catch (exe) {
          return [];
        }
    }
};